.list{
    @apply flex flex-col gap-3 px-6 my-8
}

.edit{
    @apply cursor-pointer opacity-0 ml-4 ease-out duration-1000
} 

.title{
    @apply text-3xl pb-5 border-solid border-slate-300 border-b-2 w-full flex items-center
}

.title input{
    @apply border-0 outline-0
}

.title:hover .edit {
    @apply opacity-25 hover:opacity-40
}

.addTaskBtn{
    @apply w-full flex gap-x-[10px] items-center opacity-50 duration-300 hover:opacity-100 
}
